import React, { Component } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import moment from "moment";
import {
  createNotification,
  getNotificationAdmin,
  getUserList,
} from "../../Endpoint/Admin/index";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import { C, Btn, Chip, ConfirmDialog } from "../../components/Console/ConsoleUI";
import { canWrite } from "../../services/PermissionService";
import logo from "../../assets/images/logo-sm-light.png";

/**
 * Broadcast composer (F3 of the handoff).
 *
 * The design draws a channel picker, a deep link, a send-at / expires pair and
 * an open-rate per past broadcast. createNotification accepts only
 * title / details / allUser / users, and getNotificationAdmin returns only
 * title / details / notiUniqId / type / createdAt — so those controls and
 * figures are left out rather than faked. Estimated reach is the real audience
 * count from getUserList.
 */

// Notification.type, as the API documents it. Broadcasts composed here are
// always type 4; the rest arrive from the system and share this feed.
const TYPE_LABEL = {
  1: "Food",
  2: "Room",
  3: "Table",
  4: "Broadcast",
  5: "Taxi",
  6: "Chat",
  7: "Room cancellation",
  8: "Transport",
};

const CSS = `
.bc-input{width:100%;height:48px;padding:0 15px;background:${C.surface};
  border:1px solid ${C.border};border-radius:12px;font-size:15px;color:${C.ink};
  font-family:inherit;outline:none}
.bc-input:focus{background:#fff;border-color:${C.sand}}
.bc-input::placeholder{color:${C.taupeLight}}
textarea.bc-input{height:auto;min-height:118px;padding:13px 15px;line-height:1.55;resize:vertical}
.bc-select .bc__control{min-height:48px;background:${C.surface};
  border:1px solid ${C.border};border-radius:12px;box-shadow:none}
.bc-select .bc__control--is-focused{background:#fff;border-color:${C.sand}}
.bc-select .bc__multi-value{background:${C.brown};border-radius:15px;padding:2px 4px 2px 8px}
.bc-select .bc__multi-value__label{color:#fff;font-size:13px}
.bc-select .bc__multi-value__remove{color:#fff;border-radius:12px}
.bc-select .bc__multi-value__remove:hover{background:${C.brownDeep};color:#fff}
.bc-select .bc__placeholder{color:${C.taupeLight};font-size:14px}
.bc-select .bc__option--is-focused{background:${C.iconTint}}
.bc-select .bc__option--is-selected{background:${C.brown}}
`;

const Label = ({ children }) => (
  <div style={{ fontSize: 13, letterSpacing: ".4px", color: C.taupe, marginBottom: 7 }}>
    {children}
  </div>
);

const Card = ({ children, style }) => (
  <div
    style={{
      background: "#fff", border: `1px solid ${C.tint}`,
      borderRadius: 18, padding: 22, ...style,
    }}
  >
    {children}
  </div>
);

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      title: "",
      details: "",
      allUser: true,
      users: [],
      userData: [],
      audienceTotal: null,
      dropDownOpt: [],
      confirmSend: false,
      sending: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.userList();
    this.getALlluser();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  onChange(selectedOptions) {
    const selected = [];

    let selectedOption = selectedOptions || [];
    for (let i = 0; i < selectedOption.length; i++) {
      selected.push(selectedOption[i].value);
    }

    this.setState({
      users: selected,
      selectedOptions: selectedOptions || [],
    });
  }

  /** Guard rail: nothing sends without an explicit confirmation. */
  requestSend = () => {
    const { title, details, allUser, users } = this.state;
    if (!title.trim()) {
      toast.error("Give the broadcast a title");
      return;
    }
    if (!details.trim()) {
      toast.error("Write the message body");
      return;
    }
    if (!allUser && (!users || users.length === 0)) {
      toast.error("Choose at least one guest, or send to all app users");
      return;
    }
    this.setState({ confirmSend: true });
  };

  handleSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();

    const userObject = {
      title: this.state.title,
      allUser: this.state.allUser,
      users: this.state.users,
      details: this.state.details,
    };

    this.setState({ sending: true, confirmSend: false });

    createNotification(userObject)
      .then((response) => {
        if (response.status !== 200) {
          toast.error(response.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          this.setState({
            title: "",
            details: "",
            users: [],
            selectedOptions: [],
            allUser: true,
          });
          this.getALlluser();
          toast.success(response.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        toast.error("error");
      })
      .finally(() => {
        this.setState({ sending: false });
      });
  }

  userList() {
    getUserList()
      .then((result) => {
        this.setState({
          userData: result.data,
          // The endpoint paginates; `total` is the real size of the audience
          // "all users" would reach, not just the page we hold.
          audienceTotal:
            typeof result.total === "number" ? result.total : (result.data || []).length,
        });
        const dropDownValue = this.state.userData.map((response) => ({
          value: response._id,
          label: `${response.firstName || ""} ${response.lastName || ""}`.trim() ||
            response.email ||
            "Unnamed guest",
        }));
        this.setState({ dropDownOpt: dropDownValue });
      })
      .catch((error) => {});
  }

  getALlluser() {
    getNotificationAdmin().then((result) => {
      this.setState({
        isLoaded: true,
        items: result.data || [],
      });
    });
  }

  // --- Composer -------------------------------------------------------------

  renderComposer(write) {
    const { title, details, allUser, dropDownOpt, selectedOptions, userData } = this.state;

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 18, minWidth: 0 }}>
        <Card>
          <div style={{ fontSize: 17, fontWeight: 500, color: C.ink }}>Message</div>
          <div style={{ marginTop: 18, display: "flex", flexDirection: "column", gap: 16 }}>
            <div>
              <Label>TITLE</Label>
              <input
                className="bc-input"
                id="title"
                value={title}
                onChange={this.handleChange}
                disabled={!write}
                placeholder="Rooftop happy hour tonight"
              />
            </div>
            <div>
              <Label>BODY</Label>
              <textarea
                className="bc-input"
                id="details"
                value={details}
                onChange={this.handleChange}
                disabled={!write}
                placeholder="What do you want your guests to know?"
              />
              <div style={{ marginTop: 6, textAlign: "right", fontSize: 12, color: C.taupeLight }}>
                {details.length} character{details.length === 1 ? "" : "s"}
              </div>
            </div>
          </div>
        </Card>

        <Card>
          <div style={{ fontSize: 17, fontWeight: 500, color: C.ink }}>Audience</div>
          <div style={{ marginTop: 16, display: "flex", gap: 10, flexWrap: "wrap" }}>
            {[
              { value: true, label: "All app users" },
              { value: false, label: "Chosen guests" },
            ].map((o) => (
              <button
                key={String(o.value)}
                type="button"
                disabled={!write}
                onClick={() => this.setState({ allUser: o.value })}
                style={{
                  padding: "9px 18px", borderRadius: 19, fontSize: 14, fontFamily: "inherit",
                  cursor: write ? "pointer" : "default",
                  background: allUser === o.value ? C.brown : "#fff",
                  color: allUser === o.value ? "#fff" : C.taupe,
                  border: allUser === o.value ? "1px solid transparent" : `1px solid ${C.border}`,
                }}
              >
                {o.label}
              </button>
            ))}
          </div>

          {allUser ? (
            <div style={{ marginTop: 16, fontSize: 14, color: C.taupe, lineHeight: 1.55 }}>
              Every guest account on this hotel receives it. Admin accounts are
              excluded by the server.
            </div>
          ) : (
            <div style={{ marginTop: 16 }}>
              <Label>GUESTS</Label>
              <Select
                className="bc-select"
                classNamePrefix="bc"
                options={dropDownOpt}
                value={selectedOptions}
                onChange={this.onChange.bind(this)}
                isMulti
                isDisabled={!write}
                placeholder="Search and pick guests…"
              />
              <div style={{ marginTop: 8, fontSize: 12, color: C.taupeLight }}>
                {(userData || []).length} guest{(userData || []).length === 1 ? "" : "s"} loaded
                — the list is the first page returned by the user directory.
              </div>
            </div>
          )}
        </Card>
      </div>
    );
  }

  // --- Right rail -----------------------------------------------------------

  renderRail() {
    const { title, details, allUser, users, audienceTotal, items, isLoaded } = this.state;
    const reach = allUser ? audienceTotal : (users || []).length;

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 18, minWidth: 0 }}>
        <div style={{ background: C.brown, borderRadius: 18, padding: 22, color: "#fff" }}>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,.62)", letterSpacing: ".6px" }}>
            THIS BROADCAST REACHES
          </div>
          <div style={{ marginTop: 10, fontSize: 38, fontWeight: 500, lineHeight: 1 }}>
            {reach == null ? "—" : reach}
          </div>
          <div style={{ marginTop: 8, fontSize: 14, color: C.sand }}>
            {allUser
              ? "guest accounts · everyone but admins"
              : `guest${(users || []).length === 1 ? "" : "s"} you picked`}
          </div>
        </div>

        <Card style={{ padding: 20 }}>
          <div style={{ fontSize: 15, fontWeight: 500, color: C.ink }}>Preview</div>
          <div style={{ marginTop: 14, padding: 16, borderRadius: 16, background: C.brownDeep }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <img src={logo} alt="" style={{ width: 22, height: 22, objectFit: "contain" }} />
              <span style={{ fontSize: 12, color: "rgba(255,255,255,.6)" }}>
                HOTEL LUBUMBASHI · now
              </span>
            </div>
            <div style={{ marginTop: 10, fontSize: 15, fontWeight: 500, color: "#fff", wordBreak: "break-word" }}>
              {title.trim() || "Your title appears here"}
            </div>
            <div
              style={{
                marginTop: 5, fontSize: 13, color: "rgba(255,255,255,.72)",
                lineHeight: 1.45, whiteSpace: "pre-wrap", wordBreak: "break-word",
              }}
            >
              {details.trim() || "…and the body of the message here."}
            </div>
          </div>
        </Card>

        <Card style={{ padding: 20, flex: 1, minHeight: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 500, color: C.ink }}>Recent notifications</div>
          <div style={{ marginTop: 4, fontSize: 12, color: C.taupeLight }}>
            Broadcasts you sent, alongside system alerts
          </div>
          <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 14 }}>
            {!isLoaded ? (
              <div style={{ fontSize: 14, color: C.taupeLight }}>Loading…</div>
            ) : items.length === 0 ? (
              <div style={{ fontSize: 14, color: C.taupeLight }}>Nothing sent yet.</div>
            ) : (
              items.slice(0, 10).map((n) => (
                <div key={n._id || n.notiUniqId}>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                    <span style={{ fontSize: 14, color: C.ink }}>{n.title}</span>
                    <Chip tone={n.type === 4 ? "neutral" : "warn"}>
                      {TYPE_LABEL[n.type] || "System"}
                    </Chip>
                  </div>
                  {n.details && (
                    <div
                      style={{
                        marginTop: 3, fontSize: 13, color: C.taupe,
                        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                      }}
                    >
                      {n.details}
                    </div>
                  )}
                  <div style={{ marginTop: 3, fontSize: 12, color: C.taupeLight }}>
                    {n.createdAt ? moment(n.createdAt).format("DD MMM · HH:mm") : "—"}
                  </div>
                </div>
              ))
            )}
          </div>
        </Card>
      </div>
    );
  }

  render() {
    const { allUser, users, audienceTotal, sending, confirmSend, title } = this.state;
    const write = canWrite();
    const reach = allUser ? audienceTotal : (users || []).length;

    return (
      <ConsolePage
        title="New broadcast"
        subtitle="Push notification to the guest app"
        actions={
          write ? (
            <Btn icon="send" onClick={this.requestSend} disabled={sending}>
              {sending ? "Sending…" : "Send broadcast"}
            </Btn>
          ) : null
        }
      >
        <style dangerouslySetInnerHTML={{ __html: CSS }} />

        <div
          style={{
            display: "grid", gridTemplateColumns: "minmax(0,1fr) 400px",
            gap: 20, alignItems: "start",
          }}
        >
          {this.renderComposer(write)}
          {this.renderRail()}
        </div>

        <ConfirmDialog
          isOpen={confirmSend}
          toggle={() => this.setState({ confirmSend: false })}
          icon="send"
          tone="neutral"
          title="Send this broadcast now?"
          body={
            reach == null
              ? `“${title.trim()}” will be pushed to your guests immediately.`
              : `“${title.trim()}” will be pushed to ${reach} guest${reach === 1 ? "" : "s"} immediately.`
          }
          tip="A push cannot be recalled once it is sent. Read the preview on the right before you confirm."
          confirmText="Send now"
          onConfirm={this.handleSubmit}
          loading={sending}
        />
      </ConsolePage>
    );
  }
}

export default Notification;
